import React, { memo, useEffect, useMemo, useState } from "react";
import Modal from "@components/modal/Modal";
import "./CardSchedule.scss";
import dayjs from "dayjs";
import GoogleMapReact from "google-map-react";
import flag from "@img/icons/flag.svg";
import marker from "@img/icons/marker.svg";
import { LocationType, ScheduleType, SchoolType } from "@store/Schedule";
import { formatTimeTwoDigital } from "@utils/format";
import { connection } from "@utils/signalr";
import Swal from "sweetalert2";
import { useWidth } from "@utils/demenstion";
import { IoMapOutline } from "react-icons/io5";

interface Props {
  item: ScheduleType;
  token: string;
  getAssigment: (
    assignmentId: number,
    token: string,
    callback: (data: lastLocationType) => void
  ) => Promise<void>;
  postNotTakingReported: (
    token: string,
    scheduleId: number[],
    studentId: number,
    date: string,
    callback: () => void
  ) => Promise<void>;
  getSchedule: () => void;
  date: Date;
}

interface bus {
  lat: number;
  lng: number;
}

const CardSchedule = ({
  item,
  date,
  token,
  postNotTakingReported,
  getSchedule,
  ...props
}: Props) => {
  const { photoUrl, schedules, id, name } = item;
  const [showReportIssue, setShowReportIssue] = React.useState(false);
  const [showMap, setShowMap] = React.useState(false);
  const [center, setCenter] = useState<any>({
    lat: 1.35896,
    lng: 103.852309,
  });
  const [zoom, setZoom] = useState<number>(12);
  const [location, setLocation] = useState<LocationType | null>(null);
  const [schoolLocation, setSchoolLocation] = useState<SchoolType | null>(null);
  const [assignmentId, setAssignmentId] = useState<number | null>(null);
  const [assignmentLog, setAssignmentLog] = useState<assignmentLogType | null>(
    null
  );
  const [assignmentLog2, setAssignmentLog2] =
    useState<assignmentLogType | null>(null);
  const [bus, setBus] = useState<bus | null>(null);
  const [isConnected, setConnected] = useState(false);
  const toSchool = useMemo(
    () =>
      schedules && schedules.length !== 0
        ? schedules.find((schedule) => schedule.routeType === "to_school")
        : undefined,
    [schedules]
  );
  const fromSchool = useMemo(
    () =>
      schedules && schedules.length !== 0
        ? schedules.find((schedule) => schedule.routeType === "from_school")
        : undefined,
    [schedules]
  );

  const startConnection = async () => {
    try {
      const conn = connection(token);
      await conn.start();

      conn.on("BroadcastRealtimeVehicle", (data: any) => {
        console.log(`BROADCAST DATA FROM VEHICLE #${data.vehicle.id}`, data);
        if (data) {
          setBus({
            lat: data.vehicle.lastLocationLat,
            lng: data.vehicle.lastLocationLng,
          });
        }
      });

      await conn.invoke("JoinGroup", "assignment:" + assignmentId);

      await conn.onclose(() => {
        setConnected(false);
        console.log("CONNECTION CLOSED");
        conn.stop();
        startConnection();
      });

      console.log("SignalR Connected.");
    } catch (err) {
      console.log(err);
      await setConnected(false);
    }
  };

  useEffect(() => {
    if (assignmentId && showMap) {
      startConnection();
      props.getAssigment(assignmentId, token, (data: lastLocationType) => {
        if (data) {
          setBus({
            lat: data.vehicle.lastLocationLat,
            lng: data.vehicle.lastLocationLng,
          });
        }
      });
    }
  }, [assignmentId, showMap]);

  const HouseMarker = (props: any) => {
    return (
      <div className="Marker-Wrapper">
        <img className="Marker-Icon-Flag" src={flag} alt="Flag Marker" />
      </div>
    );
  };

  const BusMarker = (props: any) => {
    return (
      <div className="Marker-Wrapper">
        <img className="Marker-Icon" src={marker} alt="Bus Marker" />
      </div>
    );
  };

  const Location = (location: LocationType) => {
    return (
      <>
        <p className="mb-3 header--16 CardDiraction__textLocHeader">{"Home"}</p>
        <p className="body--14 CardDiraction__textLocBody">
          {location.address}
        </p>
        {location.remark ? (
          <p className="body--14 CardDiraction__textLocBody">
            {`(${location.remark})`}
          </p>
        ) : null}
      </>
    );
  };

  const SchoolLocation = (location: SchoolType) => {
    return (
      <>
        <p className="mb-3 header--16 CardDiraction__textLocHeader">
          {location.name}
        </p>
        <p className="body--14 CardDiraction__textLocBody">
          {location.address}
        </p>
      </>
    );
  };

  const Assignment = (
    assignment: assignmentLogType | null,
    isNotTakingReported: boolean
  ) => {
    if (isNotTakingReported) {
      return "CardDiraction--red CardDiraction--destination--red";
    }
    if (assignment?.type === "alighted") {
      return "CardDiraction--green CardDiraction--destination--green";
    }
    if (assignment?.type === "absented" || assignment?.type === "not_taking") {
      return "CardDiraction--red CardDiraction--destination--red";
    }
    if (assignment?.type === "boarded") {
      return "CardDiraction--green CardDiraction--destination--grey";
    }
    return "CardDiraction--grey CardDiraction--destination--grey";
  };

  const postNotTaking = async (
    notTakingSchedule: string,
    callback: () => void
  ) => {
    let ids: number[] = [];
    if (schedules) {
      schedules.forEach((schedule) => {
        if (
          notTakingSchedule === "toSchool" &&
          schedule.routeType === "to_school" &&
          schedule.busSchedulePlanId
        ) {
          ids.push(schedule.busSchedulePlanId);
        } else if (
          notTakingSchedule === "fromSchool" &&
          schedule.routeType === "from_school" &&
          schedule.busSchedulePlanId
        ) {
          ids.push(schedule.busSchedulePlanId);
        } else if (
          notTakingSchedule === "toSchool and fromSchool" &&
          schedule.busSchedulePlanId
        ) {
          ids.push(schedule.busSchedulePlanId);
        }
      });
      if (ids.length !== 0) {
        await postNotTakingReported(
          token,
          ids,
          id,
          dayjs(date).format("YYYY-MM-DDTHH:mm:ss[Z]"),
          () => {
            setShowReportIssue(false);
            getSchedule();
            callback();
          }
        );
      }
    }
  };

  const NotTakingAction = (schedule: string) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await postNotTaking(schedule, () => {
          Swal.fire("Success", "Your action is being reported", "success");
        });
      }
    });
  };

  return (
    <div className="CardSchedule__container">
      <div className="CardSchedule__head">
        <div className="row">
          <div className="col-sm-6 CardSchedule__conatinerUser">
            <div className="CardSchedule__displayPic">
              <img
                src={photoUrl || "https://eagro.com.my/image/user1.jpg"}
                className="CardSchedule__image"
              />
            </div>
            <h1 className="CardSchedule__nameText">{name}</h1>
          </div>
          <div className="col-sm-6">
            <a
              className={`CardSchedule__btn ${
                dayjs(new Date()).isAfter(date, "day") ? "disabled" : ""
              }`}
              onClick={() => setShowReportIssue(true)}
            >
              REPORT NOT TAKING
            </a>
          </div>
        </div>
        <div className="CardDiraction__gridWrapper">
          {schedules
            ? schedules?.map((schedule, i) => {
                let tempAssignmentLog: assignmentLogType | null = null;

                for (let i = 0; i < schedule.assignmentLogs.length; i++) {
                  if (tempAssignmentLog === null) {
                    tempAssignmentLog = schedule.assignmentLogs[i];
                  } else {
                    const time1 = dayjs(tempAssignmentLog.loggedAt);
                    const time2 = dayjs(schedule.assignmentLogs[i].loggedAt);
                    if (time1.isBefore(time2)) {
                      tempAssignmentLog = schedule.assignmentLogs[i];
                    }
                  }
                }

                const colorSchedule = Assignment(
                  tempAssignmentLog,
                  schedule ? schedule.isNotTakingReported : false
                );
                return (
                  <div
                    key={`${schedule.assignmentId}${i}`}
                    className={`CardDiraction__timelineMainWrapper ${colorSchedule}`}
                  >
                    <div
                      onClick={() => {
                        setShowMap(true);
                        setLocation(schedule.location);
                        setSchoolLocation(schedule.school);
                        setAssignmentId(schedule.assignmentId);
                      }}
                    >
                      <IoMapOutline className="CardDiraction__mapIcon" />
                    </div>
                    <section className="CardDiraction__timelineInnerGridMainWrapper CardDiraction__scheduledRideWrapper">
                      <div className="CardDiraction__timeBusGrid">
                        <p className="header--14 CardDiraction__textTime">
                          {schedule.routeType === "to_school"
                            ? formatTimeTwoDigital(schedule.location.arrivedAt)
                            : null}
                        </p>

                        <p className="header--16 CardDiraction__textBus">
                          {schedule.routeName || "-"}
                        </p>
                      </div>
                      <div className="CardDiraction__status--wLine" />
                      <div className="CardDiraction__location">
                        {schedule.routeType === "to_school"
                          ? Location(schedule.location)
                          : SchoolLocation(schedule.school)}
                      </div>
                    </section>

                    <section className="CardDiraction__timelineInnerGridMainWrapper CardDiraction--destination">
                      <div className="CardDiraction__timeBusGrid">
                        <p className="header--14 CardDiraction__textTime">
                          {schedule.routeType === "to_school"
                            ? null
                            : formatTimeTwoDigital(schedule.location.arrivedAt)}
                        </p>
                        <p className="header--20 scheduledRideTimeline__textBus"></p>
                      </div>
                      <div className="CardDiraction__status" />
                      <div className="CardDiraction__location">
                        {schedule.routeType === "from_school"
                          ? Location(schedule.location)
                          : SchoolLocation(schedule.school)}
                      </div>
                    </section>
                  </div>
                );
              })
            : null}
        </div>
      </div>

      <Modal
        showModal={showReportIssue}
        handleClose={() => {
          setShowReportIssue(false);
        }}
        maxWidth={useWidth() > 768 ? 500 : "100%"}
      >
        <div className="CardSchedule__ReportIssueWrapper">
          <h1 className="CardSchedule__nameText">{name}</h1>
          <h1 className="CardSchedule__timeText">
            {dayjs(date).format("ddd DD MMM YYYY")}
          </h1>

          <div className="margin_40" />
          {toSchool && fromSchool && (
            <div
              className="CardSchedule__buttonWrapper"
              onClick={() => {
                NotTakingAction("toSchool and fromSchool");
              }}
            >
              <h2 className="CardSchedule__buttonText">Not going to school</h2>
              <h3 className="CardSchedule__buttonText2">(No AM and PM bus)</h3>
            </div>
          )}
          {toSchool && (
            <div
              className="CardSchedule__buttonWrapper"
              onClick={() => {
                NotTakingAction("toSchool");
              }}
            >
              <h2 className="CardSchedule__buttonText">Not taking AM bus</h2>
              <h3 className="CardSchedule__buttonText2">(No AM bus)</h3>
            </div>
          )}
          {fromSchool && (
            <div
              className="CardSchedule__buttonWrapper"
              onClick={() => {
                NotTakingAction("fromSchool");
              }}
            >
              <h2 className="CardSchedule__buttonText">Not taking PM bus</h2>
              <h3 className="CardSchedule__buttonText2">
                (No PM/CCA/Cross-Transfer bus)
              </h3>
            </div>
          )}
        </div>
      </Modal>

      <Modal
        showModal={showMap}
        handleClose={() => {
          setShowMap(false);
          setAssignmentId(null);
          setConnected(false);
          setBus(null);
        }}
      >
        <h1 className="CardSchedule__mapName">{name}</h1>
        <div className="CardSchedule__map">
          <GoogleMapReact
            bootstrapURLKeys={{
              key: "AIzaSyDMj7iqiIHemoW4TY-J-ahfNGGC_Gg6QLA",
            }}
            defaultCenter={{
              lat: bus?.lat || 1.35896,
              lng: bus?.lng || 103.852309,
            }}
            defaultZoom={bus?.lat && bus?.lng ? 14 : 11}
            onChange={(mapValue: any) => {
              setZoom(mapValue.zoom);
              setCenter(mapValue.center);
            }}
            yesIWantToUseGoogleMapApiInternals
            onGoogleApiLoaded={({ map, maps }) => {}}
          >
            {location && (
              <HouseMarker key={1} lat={location.lat} lng={location.lng} />
            )}
            {schoolLocation && (
              <HouseMarker
                key={2}
                lat={schoolLocation.lat}
                lng={schoolLocation.lng}
              />
            )}
            {bus && <BusMarker key={4} lat={bus.lat} lng={bus.lng} />}
          </GoogleMapReact>
        </div>
      </Modal>
    </div>
  );
};

export default memo(CardSchedule);
